import * as DrupalModel from "../../../custom_models/drupal"
import { getCookie, setCookie } from "../../../custom_utils/cookies"
import { pushLocationSelectionAction } from "../datalayer"
import { AsyncState, loadingAsyncState } from "widgets-for-react"
import { fetchBranchLocations } from "./LocalizationApi"

export const PREF_BRANCH_COOKIE = "preferred-branch"
export const PREF_BRANCH_COOKIE_TOAST = "preferred-branch-show-toast"

export type LocalizationState = {
  selectedLocationId: string
  branchLocations: AsyncState<DrupalModel.Location[]>
}

export const initialLocalizationState: LocalizationState = {
  selectedLocationId: getCookie(PREF_BRANCH_COOKIE) ? getCookie(PREF_BRANCH_COOKIE) : "",
  branchLocations: loadingAsyncState(fetchBranchLocations)
}

export const confirmLocation = (locationId: string, branchLocations: DrupalModel.Location[]) => {
  if (locationId == undefined) return
  const preferredBranch = branchLocations.find((loc) => loc.id == locationId)
  setCookie(PREF_BRANCH_COOKIE, locationId, 1000)
  setCookie(PREF_BRANCH_COOKIE_TOAST, 'true', 1)
  pushLocationSelectionAction(preferredBranch ? preferredBranch.title : "Geen locatie")
  window.location.reload();
}
